export default {"src":"/_next/static/media/pattern-blocks.59ff750c.svg","height":115,"width":154,"blurWidth":0,"blurHeight":0};